import { render, staticRenderFns } from "./AppointmentManagementWrapper.vue?vue&type=template&id=d39d04ee"
import script from "./AppointmentManagementWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports